// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Kr7VF","header":"ReportDetails_header__8WEBe","title":"ReportDetails_title__3Xg03","left":"ReportDetails_left__3DK0a"};